import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import TransactionActions from 'actions/Transaction';
import {
  List,
  ListItem,
  Styles,
  Toolbar,
  ToolbarGroup,
  ToolbarTitle,
  FlatButton,
  Dialog
} from 'material-ui';
import { FormattedMessage } from 'react-intl';
import Message from 'services/Message';
import * as SvgIcons from 'components/Material/SvgIcons';
import ToolbarIconButton from 'components/Material/ToolbarIconButton';
import ScrollableContainer from 'components/ScrollableContainer';

import { translate as _l } from 'oxygen-i18n';

addTranslations({
  ['en-US']: {
    'refundConfirm': 'Are you sure you want to refund?',
    'refund': 'Refund',
    'cancel': 'Cancel'
  },
  ['sv-SE']: {
    'refundConfirm': 'Är du säker på att du vill återbetala?',
    'refund': 'Återbetala',
    'cancel': 'Avbryt'
  }
});

let {
  ContentClear,
  ActionLabel,
  NavigationRefresh,
  ContentRemoveCircle,
  ActionDescription,
  EditorAttachMoney,
  DeviceAccessTime,
  ActionFace
} = SvgIcons;
let { Spacing } = Styles;

export default class TransactionForm extends mixin(
  RefluxMixin,
  Authorizer,
  Component
) {

  static contextTypes = {
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  listenToActions() {
    this.listenToAction(TransactionActions.resendComplete, transaction => {
      Message.info(this.context.getIntlMessage('transaction.receiptResent'));
    });

    this.listenToAction(TransactionActions.exportComplete, transaction => {
      Message.info(this.context.getIntlMessage('transaction.exportDone'));
    });

    this.listenToAction(TransactionActions.exportStatisticComplete, transaction => {
      Message.info(this.context.getIntlMessage('transaction.exportStatisticDone'));
    });

    this.listenToAction(TransactionActions.refundComplete, transaction => {
      Message.info(this.context.getIntlMessage('transaction.refundDone'));
    });

    this.listenToAction(TransactionActions.refundError, errorMessage => {
      this.onError(errorMessage);
      this.refs.confirmDialog.dismiss();
    });
  }

  onError(errorMessage) {
    Message.info(errorMessage);
  }

  closeDetail() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleOpen = () => {
    this.refs.confirmRefundDialog.show()
  }

  resend() {
    TransactionActions.resend(this.props.transaction.id);
  }

  refund() {
    TransactionActions.refund(this.props.transaction.id);
  }

  export() {
    TransactionActions.export(this.props.transaction.id);
  }

  statusText(status) {
    switch (status) {
      case 4:
        return 'Waiting (for approval from Klarna)';
      case 8:
      case 16:
        return 'OK';
      case 32:
        return 'Error';
      case 128:
        return this.context.getIntlMessage('transaction.refunded');
      default:
        return 'Unkonwn';
    }
  }

  render() {
    let transaction = this.props.transaction;
    let confirmActions = [{ text: 'Cancel' }];
    const actions = [
      {text: _l`cancel`},
      {text: _l`refund`, onTouchTap: this.refund.bind(this)}
    ];
    let toolbar = (
      <Toolbar>
        <ToolbarGroup float={'left'} key={0}>
          <ToolbarTitle text={this.context.getIntlMessage('Transaction')} />
        </ToolbarGroup>
        <ToolbarGroup float={'right'} key={1}>
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('transaction.resendReceipt')}
            tooltipPosition="bottom-center"
            svgIcon={<NavigationRefresh />}
            onTouchTap={this.resend.bind(this)}
          />
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('transaction.refund')}
            tooltipPosition="bottom-center"
            svgIcon={<ContentRemoveCircle />}
            onTouchTap={this.handleOpen}
          />
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('Close')}
            tooltipPosition="bottom-center"
            svgIcon={<ContentClear />}
            onTouchTap={this.closeDetail.bind(this)}
          />
        </ToolbarGroup>
      </Toolbar>
    );
    return (
      <ScrollableContainer header={toolbar}>
        <List>
          <ListItem
            disabled={true}
            leftIcon={<EditorAttachMoney />}
            primaryText={transaction.amount + ' ' + transaction.currency}
          />
          <ListItem
            disabled={true}
            leftIcon={<DeviceAccessTime />}
            primaryText={transaction.date}
          />
          <ListItem
            disabled={true}
            leftIcon={<ActionFace />}
            primaryText={transaction.buyer}
          />
          <ListItem
            disabled={true}
            leftIcon={<ActionLabel />}
            primaryText={this.statusText(transaction.status)}
          />
          <ListItem
            disabled={true}
            leftIcon={<ActionDescription />}
            primaryText={transaction.cart[0] ? transaction.cart[0].name : '—'}
          />
        </List>
        <Dialog
          ref="confirmDialog"
          title={this.context.getIntlMessage('transaction.remove')}
          actions={confirmActions}
          actionFocus="submit"
          dismissOnClickAway={true}
        >
          <FormattedMessage
            message={this.context.getIntlMessage(
              'transaction.removeTransaction'
            )}
            transaction={'transaction.code'}
          />
        </Dialog>
        <Dialog
          ref="confirmRefundDialog"
          title={this.context.getIntlMessage('transaction.refund')}
          actions={actions}
        >
          {_l`refundConfirm`}
        </Dialog>
      </ScrollableContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Transaction/Detail.js